import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { selectData, setIsPoStatus, projectPoNumber } from "../../../services/store/userSlice";
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect } from "react";
import { timesheetApi, allocationService } from "../../../services";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { parseDate } from "../../../services/axios/common/utilService";
import ProjectDeallocation from "./projectDeallocationDialoge";
import CreateProjectAllocation from "./projectAllocationDialoge";
import "./style.scss";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Calendar } from "primereact/calendar";
import { useFormik } from "formik";
import moment from "moment";
import { InputText } from "primereact/inputtext";

const MyProjectDetail = () => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState({});
  const [updatedUserData, setUpdatedUserData] = useState([]);
  const menu = useRef(null);
  const projectDetailData = useSelector(selectData);
  const { search } = useLocation();
  const projectId = new URLSearchParams(search).get("projectId");
  const [allocatedResource, setAllocatedResource] = useState([]);
  const [showNewAllocation, setShowNewAllocation] = useState(false);
  const [viewAllocation, setViewAllocation] = useState(false);
  const [clickedUserData, setClickedUserData] = useState([]);
  const [clickedUserName, setClickedUserName] = useState();
  const [currentData, setCurrentData] = useState({});
  const [projectPercentage, setProjectPercentage] = useState([]);
  const [isEndDateUpdate, setIsEndDateUpdate] = useState(false);
  const [projectEndDate, setProjectEndDate] = useState(
    projectDetailData?.endDate
  );
  const [projetcPoNumber, setProjetcPoNumber] = useState([]);
  const projectPoNumStatus = useSelector(projectPoNumber);

  useEffect(() => {
    fetchAllocationByProject(projectId);
    fetchProjectComplationPercentage(projectId);
    setProjetcPoNumber(projectDetailData?.PoProject);
  }, []);

  /* For Update Project End date */
  const formik = useFormik({
    initialValues: {
      project: projectId,
      projectEndDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.projectEndDate) {
        errors.projectEndDate = "End Date is required*";
      }
      return errors;
    },
    onSubmit: (data) => {
      const dataObj = {
        projectId: projectId,
        endDate: moment(data.projectEndDate).format("YYYY-MM-DD"),
      };
      try {
        allocationService.updateProjectEndDate(dataObj).then(
          (resp) => {
            if (resp.status) {
              setProjectEndDate(data.projectEndDate);
              formik.resetForm();
              setIsEndDateUpdate(false);
              toast.success("End date updated successfully!");
            }
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to update end date...");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  /* For Update Project End date */

  const fetchAllocationByProject = (projectId) => {
    allocationService.getAllocationByProject(projectId).then((resp) => {
      try {
        setAllocatedResource(resp?.data?.data);
        dispatch(setIsPoStatus(resp?.data?.isPoNumber));
      } catch (error) {
        console.log(error);
      }
    });
  };

  const fetchProjectComplationPercentage = (projectId) => {
    allocationService.getProjectComplationPercentage(projectId).then((resp) => {
      try {
        if (resp?.data == null) {
          setProjectPercentage([]);
        } else {
          setProjectPercentage(resp?.data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    });
  };

  const onClickAdd = () => {
    setEditData({});
    setShowNewAllocation(true);
  };

  const onClickEdit = (currentEditData) => {
    let userData = [
      {
        name: currentEditData?.firstName + " " + currentEditData?.lastName,
        id: currentEditData?.userId,
        isBillable: currentEditData?.isBillable,
        designation: currentEditData?.userProjectRole,
        availability: currentEditData?.availability,
      },
    ];
    setUpdatedUserData(userData);
    setEditData(currentEditData);
    setShowNewAllocation(true);
  };

  const renderHeader = () => {
    return (
      <>
        <div className="p-0 info info_mobile">
         
              
                <div className="grid mb-2">
                  <div className="col grid">
                    <div className="col-6 label">ProjectId</div>
                    <div className="col-6 value bordered">
                      {projectDetailData?.code}
                    </div>
                  </div>
                  <div className="col grid">
                    <div className="col-6 label">Project Name</div>
                    <div className="col-6 value bordered">
                      {projectDetailData?.title}
                    </div>
                  </div>
                </div>
                <div className="grid mb-2">
                  <div className="col grid">
                    <div className="col-6 label">Client</div>
                    <div className="col-6 value bordered">
                      {projectDetailData?.customers?.title}
                    </div>
                  </div>
                  <div className="col grid">
                    <div className="col-6 label">Project Type</div>
                    <div className="col-6 value bordered">
                      {projectDetailData?.projectTypes?.title}
                    </div>
                  </div>
                </div>
                <div className="grid mb-2">
                  <div className="col grid">
                    <div className="col-6 label">Manager</div>
                    <div className="col-6 value capitalize bordered">
                      {projectDetailData?.pmDetails?.firstName +
                        " " +
                        projectDetailData?.pmDetails?.lastName}
                    </div>
                  </div>
                  <div className="col grid">
                    <div className="col-6 label">Project Group</div>
                    <div className="col-6 value bordered">
                      {projectDetailData?.projectGroup ? projectDetailData?.projectGroup : ''}
                    </div>
                  </div>
                </div>
                <div className="grid mb-2">
                  <div className="col">
                    <div className="grid">
                      <div className="col-6 label">Project Complete(%)</div>
                      <div className="col-6 value bordered">
                        {projectPercentage?.percentage
                          ? projectPercentage?.percentage
                          : 0}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="grid">
                      <div className="col-6 label">Start Date</div>
                      <div className="col-6 value bordered">
                        {parseDate(projectDetailData?.startDate)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="grid mb-2">
                  <div className="col grid">
                    <div className="col-6 label">PO Number</div>
                    <div className="col-6 value bordered">
                      {projetcPoNumber?.poNumber
                        ? projetcPoNumber?.poNumber
                        : "N/A"}
                    </div>
                  </div>
                  <div className="col grid">
                    <div className="col-6 label">End Date</div>
                    <div className="col-6 value bordered">
                      {parseDate(projectEndDate)}
                    </div>
                  </div>
                </div>
              
           
        </div>

        <div className="grid mt-3 mb-3">
          <div className="col pt-3">
            <div className="col-12 t-header">
              <strong style={{ fontSize: "20px", fontWeight: "400" }}>
                Allocated Resources
              </strong>
              <div className="" style={{ float: "right" }}>
                <Button
                  icon="pi pi-plus"
                  label="Create New Allocation"
                  onClick={() => {
                    onClickAdd();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const header = renderHeader();
  const AllocationBody = (rowData) => {
    let resp = "";
    if (rowData.allocationType === 1 || rowData.allocationType === 2) {
      resp = rowData.percentage + "%";
    } else if (rowData.allocationType === 3) {
      resp = "OT";
    } else {
      resp = "Shadow";
    }
    return (
      <span
        className="bordered"
        style={{
          minWidth: "75px",
          textAlign: "center",
          display: "inline-block",
        }}
      >
        {resp}
      </span>
    );
  };
  const NameBody = (rowData) => {
    let resp = "";
    resp = rowData.firstName + " " + rowData.lastName;
    return <span className="capitalize">{resp}</span>;
  };
  const BillableBody = (rowData) => {
    return (
      <span className="capitalize">
        <Checkbox checked={rowData.isBillable} />
      </span>
    );
  };
  const RateBody = (rowData) => {
    let resp = [];
    if (rowData.currency) {
      resp.push(
        <span style={{ fontWeight: "500", color: "red" }}>
          {rowData.currency}
        </span>
      );
    }
    if (rowData.isBillable) {
      if (rowData.billingRate && rowData.billingType) {
        resp.push(<>&nbsp;{rowData.billingRate} /&nbsp;</>);
      } else {
        resp.push(<>&nbsp; 0 /&nbsp;</>);
      }
    } else {
      resp.push(<>&nbsp; 0 /&nbsp;</>);
    }

    if (rowData.billingType) {
      resp.push(<>{rowData.billingType}</>);
    }
    return (
      <>
        {resp.length > 0 && <span className="capitalize bordered">{resp}</span>}
      </>
    );
  };
  const DateBody = (rowData, options) => {
    return <>{parseDate(rowData[options.field])}</>;
  };

  const reviewActionBodyTemplate = (rowData) => {
    const items = [
      {
        label: "Allocation",
        items: [
          {
            label: "Delete Allocation",
            icon: "pi pi-trash",
            command: (e) => {
              onClickDeallocation(currentData);
            },
          },
          {
            label: "Update Allocation",
            icon: "pi pi-pencil",
            command: (e) => {
              onClickEdit(currentData);
            },
          },
        ],
      },
    ];
    return (
      <>
        <Menu
          style={{ width: "180px" }}
          id={"m-" + rowData.id}
          model={items}
          popup
          ref={menu}
        />
        <Button
          className="p-button-rounded p-button-text"
          id={"b-" + rowData.id}
          icon="pi pi-ellipsis-v"
          onClick={(event) => {
            setCurrentData(rowData);
            menu.current.toggle(event);
          }}
          aria-controls={"m-" + rowData.id}
          aria-haspopup
        />
      </>
    );
  };

  const updateData = (data) => {
    allocationService.updateAllocation(data).then(
      (resp) => {
        if (resp) {
          setShowNewAllocation(false);
          onLoad();
          toast.success("Allocation updated successfully!");
        }
      },
      (err) => {
        toast.error("Unable to update allocation");
      }
    );
  };

  const NewAllocationDialog = () => {
    return (
      <>
        <Dialog
          header={
            editData.allocationId
              ? "Update Project Allocation"
              : "New Project Allocation"
          }
          visible={showNewAllocation}
          className="dialog_lg"
          onHide={() => setShowNewAllocation(false)}
        >
          <CreateProjectAllocation
            editData={editData}
            userAllocaionType={editData.allocationId ? true : false}
            updateData={(data) => updateData(data)}
            onClose={(e) => {
              setShowNewAllocation(false);
            }}
            projectName={projectDetailData.title}
            projectStart={projectDetailData.startDate}
            projectEnd={projectDetailData.endDate}
            projectId={projectId}
            onLoad={() => onLoad()}
            currentUserData={updatedUserData}
            poStatus={projectPoNumStatus}
            projectPo={projectDetailData?.PoProject}
          />
        </Dialog>
      </>
    );
  };

  const onClickDeallocation = (rowData) => {
    confirmDialog({
      message: "Do you want to deallocate this record?",
      header: "Deallocation Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const reject = () => {
    // onClose();
  };

  const accept = () => {
    let param = {
      ids: [currentData.allocationId],
    };
    timesheetApi.updateDeallocation(param).then(
      (resp) => {
        if (resp) {
          onLoad();
          toast.success("User Deallocated successfully!");
        }
      },
      (error) => { }
    );
  };

  const onLoad = () => {
    fetchAllocationByProject(projectId);
  };

  const ViewAllocationDialog = () => {
    return (
      <>
        <Dialog header={"Update Allocation for (" + clickedUserName + ")"} visible={viewAllocation} style={{ width: "70vw" }} onHide={() => setViewAllocation(false)}>
          <ProjectDeallocation onClose={(e) => { setViewAllocation(false); }} projectData={clickedUserData} onLoad={() => onLoad()} projectId={projectId} />
        </Dialog>
      </>
    );
  };
  return (
    <div className="mp-panel">
      <div className="c-border">
        <DataTable stripedRows header={header} value={allocatedResource} paginator paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={8} rowsPerPageOptions={[8, 15, 20, 50, 100]} tableStyle={{ minWidth: "80rem" }}>
          <Column field="ecn" header="ECN" headerStyle={{ width: "5rem" }}></Column>
          <Column field="firstName" header="User Name" headerStyle={{ width: "15rem" }} body={NameBody}></Column>
          <Column field="percentage" header="Allocation" body={AllocationBody} headerStyle={{ width: "5rem", textAlign: "center" }}></Column>
          <Column field="userProjectRole" header="Role" headerStyle={{ width: "10rem" }}></Column>
          <Column field="isBillable" header="Billable" headerStyle={{ width: "5rem" }} body={BillableBody}></Column>
          <Column field="billingRate" header="Rate" headerStyle={{ width: "10rem" }} body={RateBody}></Column>
          <Column field="poNumber" header="PO Number" headerStyle={{ width: "10rem" }}></Column>
          <Column field="startDate" header="Start Date" headerStyle={{ width: "7rem" }} body={DateBody}></Column>
          <Column field="endDate" header="End Date" headerStyle={{ width: "7rem" }} body={DateBody}></Column>
          <Column field="status" header="Action" body={reviewActionBodyTemplate} headerStyle={{ width: "5rem" }}></Column>
        </DataTable>
      </div>
      <NewAllocationDialog />
      {viewAllocation && <ViewAllocationDialog />}
    </div>
  );
};

export default MyProjectDetail;
